import { render, staticRenderFns } from "./EmrTemplateDetail.vue?vue&type=template&id=dbec69f2&scoped=true"
import script from "./EmrTemplateDetail.vue?vue&type=script&lang=js"
export * from "./EmrTemplateDetail.vue?vue&type=script&lang=js"
import style0 from "./EmrTemplateDetail.vue?vue&type=style&index=0&id=dbec69f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbec69f2",
  null
  
)

export default component.exports